import { render } from "./FormKemitraan.vue?vue&type=template&id=c00c08b4&ts=true"
import script from "./FormKemitraan.vue?vue&type=script&lang=ts"
export * from "./FormKemitraan.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__